<ng-container *ngIf="ready">
    <convfact-subscriptionList [subscriptionList]="subscriptionList">
    </convfact-subscriptionList>
</ng-container>

<ng-container *ngIf="!ready">
    <div class="container" style="height:65vh">
        <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
    </div>
</ng-container>